import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { getOriginUrlWithHash } from '../../../utils/getOriginUrlWithHash.js';
import { ContextMenu } from '@fabric-app/ui/components/ContextMenu/ContextMenu';
import useCopyToClipboard from '@fabric-app/hooks/useCopyToClipboard';
import { openExternal } from '@fabric-app/ui/components/Link/LinkExternal';
import { DropdownItemIconContainer } from '@fabric-app/ui/components/DropdownMenu/Item';
import { IconLinkWindow, IconCopy } from '@fabric-app/icons/svg';

const ExternalSourceMenuItems = ({ url, resourceId }) => {
  const [, copy] = useCopyToClipboard();
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsxs(ContextMenu.Item, {
        onClick: () => openExternal(getOriginUrlWithHash(url, resourceId), "_blank"),
        "data-testid": "item-context-menu-go-to-source-button",
        children: [
          /* @__PURE__ */ jsx(DropdownItemIconContainer, {
            children: /* @__PURE__ */ jsx(IconLinkWindow, {})
          }),
          "Go to original URL"
        ]
      }),
      /* @__PURE__ */ jsxs(ContextMenu.Item, {
        onClick: () => copy(url),
        "data-testid": "item-context-menu-copy-source-button",
        children: [
          /* @__PURE__ */ jsx(DropdownItemIconContainer, {
            children: /* @__PURE__ */ jsx(IconCopy, {})
          }),
          "Copy original URL"
        ]
      })
    ]
  });
};

export { ExternalSourceMenuItems };
//# sourceMappingURL=ExternalSourceMenuItems.js.map
